module.exports = __webpack_public_path__ + "prod/1.42.2/img/bankeysH5-goodsImg.d44fb33e.png";